import React, { Fragment, useEffect, useState } from 'react'
import ReportGenerate from '../layout/ReportGenerate';
import GenerateReportData from '../layout/GenerateReportData';
import ViewReports from './ViewReports';
export default function TableCustomVisuals(props) {

  const baseurlKPIs = `${process.env.REACT_APP_SERVER_URL}/aipd/topKpiAndReport`;
  const baseurlReportList = `${process.env.REACT_APP_SERVER_URL}/aipd/userReportList`;
  const baseurlReportKPIs= `${process.env.REACT_APP_SERVER_URL}/aipd/userKpiList`;

  const [dataItems, setData] = useState();
  const [ReportData, setReportData] = useState();
  const [ReportDataKPIS, setReportDataKPIS] = useState();

  const [dataItemsCustom, setDataItemsCustom] = useState();

  const [DataLoading, setDataLoading] = useState(true);
  const [isLoading, setisLoading] = useState(true);

  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];


  useEffect(()=>{
    GetTopKpis()
    GetUserReportList()
    GetUserReportKPIS()
  },[passtoken])

  const GetTopKpis = async () => {
    try {
      const response = await fetch(baseurlKPIs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setData(jsonData.reportAnalysis);
        setDataItemsCustom(jsonData.customVisuals)
        setDataLoading(false)
        setisLoading(false);
      } else {
        setData([]);
        setisLoading(false);
        
      }
    } catch (err) {
      console.error("Error:", err);
      setisLoading(false);
      setData([]);
    }
  };

  const GetUserReportList = async () => {
    try {
      const response = await fetch(baseurlReportList, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        console.log(jsonData);
        setReportData(jsonData)
      } else {
        
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const GetUserReportKPIS = async () => {
    try {
      const response = await fetch(baseurlReportKPIs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        setReportDataKPIS(jsonData)
      } else {
        
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };
// console.log(ReportData)

  return (
    <>
      {isLoading && <>Please Wait..</>}

      {!isLoading && (
        <div
          style={{
            display: "grid",
            gridGap: "1rem",
            gridTemplateColumns: "49% 49%",
          }}
        >
          <div
            style={{
              boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
              height: "auto",
              padding: "1rem",
              borderRadius: "6px",
              width: "99%",
              paddingBottom: "2rem",
              display: "grid",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                fontWeight: "700",
                display: "flex",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <span style={{marginLeft:"5px"}}>Top 5 Views Report</span>
              <div style={{               
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                gap:"10px",
                marginRight:"5px"
}}>
                <div>
                  <GenerateReportData
                    excelData={ReportData}
                    fileName={`Report_${new Date().getTime()}`}
                  />
                </div>

                <div>
                  <ViewReports dataLoading={props.dataLoading} dataItem={props.data} data={ReportData}/>
                </div>
              </div>
            </div>

            <div>
              <table id="AnalyticsTable">
                <tbody>
                  <tr>
                    <th style={{ width: "30%" }}>Group</th>
                    <th style={{ width: "55%" }}>Reports</th>
                    <th style={{ width: "15%" }}>Views</th>
                  </tr>
                  {dataItems && dataItems.map((row, index) => (
                    <tr key={index}>
                      <td title={row.userGroupName}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                            justifyContent: "start",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.userGroupName}
                        </span>
                      </td>
                      <td title={row.reportName}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                            justifyContent: "start",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.reportName}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "center",
                            justifyContent: "center",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.count}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div
            style={{
              boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
              height: "auto",
              padding: "1rem",
              borderRadius: "6px",
              width: "99%",
              paddingBottom: "2rem",
              display: "grid",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                fontWeight: "700",
                display: "flex",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <span>Top 5 Usges Custom Visuals</span>

              <div>
                <GenerateReportData
                  excelData={ReportDataKPIS}
                  fileName={`Visuals_Report_${new Date().getTime()}`}
                />
              </div>
            </div>
            <div>
              <table id="AnalyticsTable">
                <tbody>
                  <tr>
                    <th style={{ width: "30%" }}>Group</th>
                    <th style={{ width: "55%" }}>Visuals</th>
                    <th style={{ width: "20%" }}>Selected</th>
                  </tr>
                  {dataItemsCustom && dataItemsCustom.map((row, index) => (
                    <tr key={index}>
                      <td title={row.userGroupName}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                            justifyContent: "start",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.userGroupName}
                        </span>
                      </td>
                      <td title={row.title}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                            justifyContent: "start",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.title}
                        </span>
                      </td>
                      <td title={row.saveCount} style={{ textAlign: "center" }}>
                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "center",
                            justifyContent: "center",
                            background: "white",
                          }}
                          className="user_items_cls items_cls font-size-new"
                        >
                          {row.saveCount}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}